import Switch from "@mui/material/Switch"
import { styled } from "@mui/material/styles"

// iOS-style pill switch — the stock MUI Switch's ripple + thin indicator
// reads as clunky next to the rest of the procurement UI. Same on/off API,
// just restyled: green track when checked, soft shadow on the thumb.
//
// The app's global MUI theme (assets/theme/components/form/switchButton.js)
// already forces its own track/thumb colors and sizing via `!important` —
// without matching `!important` here, that global override wins over a
// plain `styled()` component every time, which is why the first pass
// silently rendered unstyled (default dark track, mismatched thumb size).
const PrettySwitch = styled(Switch)(() => ({
  width: 40,
  height: 24,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 3,
    transitionDuration: "150ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff !important",
      "& .MuiSwitch-thumb": {
        borderColor: "transparent !important",
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#2E7D32 !important",
        borderColor: "#2E7D32 !important",
        opacity: "1 !important",
      },
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      opacity: 0.7,
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: "0.4 !important",
    },
  },
  "& .MuiSwitch-thumb": {
    width: 18,
    height: 18,
    backgroundColor: "#fff !important",
    border: "none !important",
    boxShadow: "0 1px 3px 0 rgba(0,0,0,0.3)",
  },
  "& .MuiSwitch-track": {
    width: "40px !important",
    height: "24px !important",
    borderRadius: 12,
    backgroundColor: "#C4CDD5 !important",
    borderColor: "#C4CDD5 !important",
    opacity: "1 !important",
    transition: "background-color 150ms",
    boxSizing: "border-box",
  },
}))

export default PrettySwitch
